var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3743 17.7904C16.7888 17.7904 17.9355 16.6437 17.9355 15.2292C17.9355 13.8147 16.7888 12.668 15.3743 12.668C13.9597 12.668 12.813 13.8147 12.813 15.2292C12.813 16.6437 13.9597 17.7904 15.3743 17.7904Z",
    fill: "#171717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3538 19.7301V33.9397H24.7658V26.9128C24.7658 25.0586 25.1146 23.2629 27.4136 23.2629C29.681 23.2629 29.7091 25.3828 29.7091 27.0298V33.9409H34.1234V26.1484C34.1234 22.3206 33.2993 19.3789 28.8253 19.3789C26.6773 19.3789 25.2375 20.5577 24.6487 21.6732H24.589V19.7301H20.3538ZM13.1642 19.7301H17.5831V33.9397H13.1642V19.7301Z",
    fill: "#171717"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedin);
export default __webpack_public_path__ + "static/media/Footer-Linkedin.538cf9def245bb6806fa428093171432.svg";
export { ForwardRef as ReactComponent };